import { EmptyStateProcessIllustration, Button } from "@octopusdeploy/design-system-components";
import type { GitRef } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import ActionList from "~/components/ActionList/ActionList";
import OnboardingPage from "~/components/GettingStarted/OnboardingPage";
interface OnboardingProps {
    slug: string;
    gitRef: GitRef;
}
const ProjectTemplateOnboarding = ({ slug, gitRef }: OnboardingProps) => {
    const createProcessHref = links.projectTemplateDeploymentProcessEditorPage.generateUrl({ slug, gitRef }, { stepTemplates: true });
    return (<OnboardingPage title="Add steps to your Project Template" intro={<>
                    <strong>Project Templates</strong> are used for standardization of projects and their dependencies to enforce structure and best practices in your deployments.
                </>} learnMore={<></>} image={<EmptyStateProcessIllustration />} actionButtons={<ActionList alignStart={true} actions={[<Button label={"Create Process"} href={createProcessHref} importance="primary"/>]}/>}/>);
};
export default ProjectTemplateOnboarding;
